var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTimeSale = function SvgTimeSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.063 11.693 5.842-7.546L20.874 9.4l2.214 13.33-13.81 2.295-2.215-13.33Z",
    fill: "#FFA0CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4 25.764a.75.75 0 0 1-.863-.617L6.323 11.816a.75.75 0 0 1 .146-.582l5.843-7.546a.75.75 0 0 1 1.006-.167l7.968 5.252a.75.75 0 0 1 .327.503l2.215 13.33a.75.75 0 0 1-.617.863L9.4 25.764Zm.494-1.603 12.331-2.048-2.038-12.268-7.115-4.69-5.216 6.738 2.038 12.268Z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.486 13 4l7 6.486V24H6V10.486Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 24.75a.75.75 0 0 1-.75-.75V10.486a.75.75 0 0 1 .24-.55l7-6.486a.75.75 0 0 1 1.02 0l7 6.486a.75.75 0 0 1 .24.55V24a.75.75 0 0 1-.75.75H6Zm.75-1.5h12.5V10.814L13 5.022l-6.25 5.792V23.25Z",
    fill: "#191919"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: "#FFA0CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 17.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z",
    fill: "#191919"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: "#FFA0CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 12.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z",
    fill: "#191919"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 13 8)",
    fill: "#191919"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.45 11.4a.75.75 0 0 1 .15 1.05l-6 8a.75.75 0 1 1-1.2-.9l6-8a.75.75 0 0 1 1.05-.15Z",
    fill: "#191919"
  })));
};

export default SvgTimeSale;